import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=9e2fda8a&scoped=true&"
import script from "./MessageTip.vue?vue&type=script&lang=ts&"
export * from "./MessageTip.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=9e2fda8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2fda8a",
  null
  
)

export default component.exports